import { TableV2 } from '@medeloop/medeloop-components-library';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetUserOverview } from 'src/api/users-queries';
import { OrganizationOverview } from 'src/types/users';

export const OrganizationsList = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const navigate = useNavigate();

  const { isLoading, data } = useGetUserOverview();

  const onRowClick = (row: OrganizationOverview) => {
    navigate(`/account/organizations/${row.organizationId}/organizational-units`);
  };

  const headers = [
    { label: 'Name', key: 'name' },
    { label: 'Display name', key: 'displayName' },
    { label: 'Researchers', key: 'researchers' },
    { label: 'Studies', key: 'studies' },
    { label: 'OUS', key: 'ous' },
    { label: 'Datasets', key: 'dataSets' },
  ];

  const transformedData = useMemo(
    () =>
      data?.organizations
        .filter(
          (organization) =>
            organization.organizationName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            organization.organizationDisplayName.toLowerCase().includes(searchTerm.toLowerCase()),
        )
        .map((organization) => ({
          id: organization.organizationId,
          name: organization.organizationName,
          displayName: organization.organizationDisplayName,
          researchers: organization.researchers,
          studies: organization.studies,
          ous: organization.organizationalUnits,
          dataSets: organization.dataSources,
          onClick: () => onRowClick(organization),
        })) ?? [],
    [data, searchTerm],
  );

  return (
    <div className="flex flex-col gap-6 p-4 bg-background-dark-subdued rounded-lg">
      <TableV2
        headers={headers}
        data={transformedData}
        isLoading={isLoading}
        searchPlaceholder="Search organizations"
        onSearch={(t) => setSearchTerm(t)}
      />
    </div>
  );
};
